import React from 'react'
import { Link } from 'react-router-dom'

const DolphinTroubleshooting = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ color: '#640000', marginBottom: '20px' }}>Dolphin PMS Troubleshooting Guide</h1>
      
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <a 
          href="https://vimeo.com/689402131/bb0ed48d0a"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '15px 25px',
            backgroundColor: '#640000',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
            fontSize: '1.1em'
          }}
        >
          Watch Troubleshooting Video Guide
        </a>
      </div>

      <div style={{ 
        backgroundColor: '#FFF3F3', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h3 style={{ color: '#640000', marginBottom: '10px' }}>Need Additional Help?</h3>
        <p>
          If you're still experiencing issues after watching the guide, please contact your Dolphin support team or reach out to us at{' '}
          <a href="mailto:requests@roostergrin.com" style={{ color: '#4A0000', textDecoration: 'underline' }}>
            requests@roostergrin.com
          </a>
        </p>
      </div>

      <Link 
        to="/" 
        style={{ 
          display: 'inline-block',
          padding: '10px 20px',
          backgroundColor: '#640000',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '4px',
          marginTop: '20px'
        }}
      >
        Return to Dashboard
      </Link>
    </div>
  )
}

export default DolphinTroubleshooting



// WEBPACK FOOTER //
// ./src/components/Troubleshooting/DolphinTroubleshooting.js